import axios from '../utils/axios';

export default function getManagedCreditRecruiters(adminId, mgr_id) {
    return axios.get(`/admin/${adminId}/credits/manager/${mgr_id}`, { });
}
